$(document).ready(function() {

	var timeoutResizeIframeId;

	$(document).on('click','.preventdefault',function(e){
		e.preventDefault();
	});

	// no margin-top on body when header is not sticky
	if ($('.nostickyheader').length) {
		$('body').css("margin-top","0");
	}

    // alert for error messages and log out message on login pages
	  function slideInAlert() {
    	$(".alert-dismissible").slideToggle(400);
	  }

	//currently readMore is only used on loginpage for the error message
	function readMore() {
		$(".readmore").on('click',function(e){
			$(this).next().toggle();
			$(this).hide();
		});
	}
	//currently moreDetails is only used on mijnverzekeringen.html for pakketten (NKC only)
	function moreDetails() {
		$(".details ul").hide();
		$(".details ul + a").on('click',function(e){
			$(this).prev("ul").slideToggle();
			$(this).find("span.icon").toggleClass("icon-chevron-down icon-chevron-up");
			//$(this).find("span.icon").toggleClass(".icon-chevron-up");
			$(this).find("span.text").text(function(i, text){
		    	return text === "Verberg pakketdetails" ? "Toon pakketdetails" : "Verberg pakketdetails";
		    })
		});
	}

	$(document).on('click','.preventScrollToTop', function(){
		window.scrollTop = window.scroll = new function() {
			// prevent service & contact iframe to scroll to top
		}
	});

	//
	// Form validator stuff
	//
	function showCheck(div){
		$(div).addClass("draw");
	}
	function hideCheck(div){
		$(div).removeClass("draw");
	}
	// validate username/email and password
	function validateInput(ifStatement, input) {
		if (ifStatement) {
			$(input).parent().addClass("has-success");
		}
		else {
			$(input).parent().removeClass("has-success");
		}
	}
	// enable button depending on input
	function enableButton(ifStatement) {
		var submitButton = $("form#validation #submit");
		if (ifStatement) {
			submitButton.removeAttr('disabled');
		}
		else {
			submitButton.prop('disabled', 'true');
		}
	}
	//disable button
    function disableButton() {
        var submitButton = $("form#validation #submit");
        submitButton.prop('disabled', 'true');
    }

	function formValidator() {
			// when input changes do something
			$("form#validation input").on("input", function(){
				var usernameHash = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				var username = $("#username").val();
				var hasUsername = usernameHash.test(username);

				var password = $("#password").val();
				var repeatPassword = $("#repeatPassword").val();
				var hasUpperCase = /[A-Z]/.test(password);
				var hasLowerCase = /[a-z]/.test(password);
				var hasNumbers = /\d/.test(password);
				var hasSpecial = /[~`!@#$%\^.&*+=_\-\[\]\\';,/{}\(\)|\\":<>\?]/.test(password);

				$("#repeatUsername").on("paste", function(e) {
					e.preventDefault();
				});
				$(".nomatch").hide();

				function equalValue() {
					if(repeatUsername === username) {
                    	$("#repeatUsername").parent().removeClass("has-error").addClass("has-success");
                    	$("#username").parent().removeClass("has-error").addClass("has-success");
                    	enableButton(repeatUsername === username);
                    	$(".nomatch").hide();
                    }
                    else {}
				}

				// VALIDATE USERNAME USER INPUT
				// username validation
				if($("form").hasClass("username") === true && $("form").hasClass("repeat-username") === false) {
					validateInput(hasUsername === true && username.length > 1, "#username");
					enableButton(hasUsername === true);
				}
				else {}

                // cheack again on focus out
                $("#username").on("focusout", function() {
                    if (hasUsername === false) {
                        $("#username").parent().removeClass("has-success").addClass("has-error");
                        disableButton();
                    } else {
                        $("#username").parent().addClass("has-success").removeClass("has-error");
                        enableButton(hasUsername === true && hasUsernameRepeat === true);
                        if (hasUsernameRepeat === true && repeatUsername !== username){
                            $("#repeatUsername").parent().removeClass("has-success").addClass("has-error");
                            $(".nomatch").show();
                        }
                        else {}

                        equalValue();

                        if($("form").hasClass("username") === true && $("form").hasClass("repeat-username") === false) {
                        	enableButton(hasUsername === true);
                        }
                        else {}
                    }
                });

		 		// repeat username validation
				if($("form").hasClass("repeat-username") === true) {
					var repeatUsername = $("#repeatUsername").val();
					var hasUsernameRepeat = usernameHash.test(repeatUsername);

					validateInput(hasUsernameRepeat === true && hasUsername === true, "#repeatUsername");
					validateInput(hasUsername === true, "#username");
					enableButton(hasUsername === true && hasUsernameRepeat === true && username === repeatUsername);
				}
				else {}
                // cheack again on focus out
                $("#repeatUsername").on("focusout", function() {
                    if (username !== repeatUsername) {
                        $("#repeatUsername").parent().removeClass("has-success").addClass("has-error");
                        disableButton();
                        $(".nomatch").show();
                    } else {
                        $("#repeatUsername").parent().addClass("has-success").removeClass("has-error");
                        $(".nomatch").hide();
                    }

                    equalValue();

                    enableButton(hasUsername === true && hasUsernameRepeat === true && username === repeatUsername);
                });



		 		// VALIDATE PASSWORD COMPLEXITY

		 		// password validation
		 		if($("form").hasClass("password") === true) {
		 		//PASSWORD HELP SECTION
					//check for uppercase
	 				if (hasUpperCase === true) {showCheck(".hasuppercase");
	 				} else {hideCheck(".hasuppercase");}
	 				// check for lowercase
	 				if (hasLowerCase === true) { showCheck(".haslowercase");
	 				} else {hideCheck(".haslowercase");}
	 				// check for number
	 				if (hasNumbers === true) { showCheck(".hasnumber");
	 				} else {hideCheck(".hasnumber");}
	 				// check for special character
	 				if (hasSpecial === true) { showCheck(".hasspecial");
	 				} else {hideCheck(".hasspecial");}
	 				//check for password length
	 				if (password.length > 7) { showCheck(".has8chars");
	 				} else {hideCheck(".has8chars");}
				// END PASSWORD HELP SECTION

					// check if password field has all required characters
		 			if (hasUpperCase === true && hasLowerCase === true && hasNumbers === true && hasSpecial === true && password.length > 7) {
		 				$("#password").parent().addClass("has-success");
		 				$(".notstrictenough").hide();
		 			} else {
		 				$(this).parent().removeClass("has-success");
		 			}
		 			// cheack again on focus out
                        $("#password").on("focusout", function() {
                            if (hasUpperCase === false || hasLowerCase === false || hasNumbers === false || hasSpecial === false || password.length < 7) {
                                $("#password").parent().removeClass("has-success").addClass("has-error");
                                $(".notstrictenough").show();
                            } else {
                                $("#password").parent().addClass("has-success").removeClass("has-error");
                                $(".notstrictenough").hide();
                            }
                        });

					// check repeat password to match first password entered
		 			if (password === repeatPassword && repeatPassword.length > 7) {
		 				$("#repeatPassword").parent().addClass("has-success");
		 				showCheck(".passwordmatch");
		 				enableButton(password === repeatPassword && repeatPassword.length > 7);
					}
		 			else {
		 				$("#repeatPassword").parent().removeClass("has-success");
		 				hideCheck(".passwordmatch");
                        $(".nomatch").hide();
                        disableButton();
		 			}

                    // cheack again on focus out
                    $("#repeatPassword").on("focusout", function() {
                        if (password !== repeatPassword) {
                            $("#repeatPassword").parent().removeClass("has-success").addClass("has-error");
                            $(".nomatch").show();
                        } else {
                            $("#repeatPassword").parent().addClass("has-success").removeClass("has-error");
                            $(".nomatch").hide();
                        }
                        enableButton(password === repeatPassword);
                    });
		 		}
		 		else {}
			});
	}
    // disable submit on enter when button is disabled
	$('form').keydown(function(event){
		if(event.keyCode == 13) {
			if($('input[type=submit]').hasClass('disabled')) {
				event.preventDefault();
				return false;
			}
			else {
				return true;
			}
		}
	});
	//
	// END Form validator stuff
	//


	// Service & Contact iframe laden
	// Frame increases height by javascript so interval is used to set the height
	function contactForm() {
		$("#ikwilcontactbtn").on("click", function() {
			// initially show loader
			$(".loaderframe.tile").show();
			$(".formframe").hide();
			// Show iframe, hide loader when iframe is loaded
			window.scrollTop = window.scroll = new function() {
				// prevent service en contact iframe to scroll to top
			};
			// set iframe src
			vm.setIframeUrl("#contactIframe", "getcontacturl");
		});
	}

	// start watch iframe size and resize if needed
	function watchIframeSize(frame){
		var frameHeight = 0, bodyHeight = 0;
		if(typeof timeoutResizeIframeId !== 'undefined') {
			clearInterval(timeoutResizeIframeId);
		}
		timeoutResizeIframeId = setInterval( function() {
			try {
				bodyHeight =  $(frame).contents().find('body').height();
				frameHeight =  $(frame).height();
				if(bodyHeight === undefined || frameHeight === undefined){
					throw "unrecognized format";
				}
				if ( (bodyHeight > frameHeight) || ((frameHeight-bodyHeight)>50) ) {
		  			frame.css('height', bodyHeight+50 + 'px' );
				}
			} catch (e) {
				frame.css('height', '1250px' );
				clearInterval(timeoutResizeIframeId);
			}
		}, 100);
	}
	// end watch iframe size and resize if needed

	// iframe global show/hide loader
	function hideLoader() {
		$(".formframe").on("load", function () {
			var frame = $(".formframe");
			$(".loaderframe").hide();
			frame.show();
			watchIframeSize(frame);
		});
	}
	// show loader when clicking on login button
	function showLoginLoader() {
		$("input[value=Inloggen]").on("click", function(){
			//setInterval( function() {
				$(this).hide();
				$(".loader-login").css("display","inline-block");
			//}, 150)
		});
	}

	// show insurances on mijnverzzekeringen when directly selected on mijnoverzicht, or elsewhere.
	function autoOpen() {
		// open nieuwe verzekeringen block (mijn verzekeringen) when clicked on nieuweverzekering on another page
		if(document.location.hash == '#nieuweverzekering') {
		    $("h3 + .produkt-shower").hide();
		    $(".insurance-list").show();
		}
		// open messages (service & contact) when clicked on messages on mijn overzicht
		if(document.location.hash == '#scrollToMessages') {
		    $("#berichten").addClass("in");
		    $("#mijnberichten > .card-header h3 > a").removeClass("collapsed");
		}
		// open ik wil contact (service & contact) when clicked on ik wil contact on mijn overzicht
		if(document.location.hash == '#ikwilcontact') {
		    $("#ikwilcontact").addClass("in active");
		    $("#ikwilcontactbtn .btn-super").addClass("active");
		    $("#ikwilcontactbtn").trigger("click");
		    $('html, body').stop().animate({
				scrollTop: $('#scrolltocontact').offset().top - 75
			}), 1000;
		}
		// open nieuwe verzekeringen block (mijn verzekeringen) when clicked on nieuweverzekering on another page
		if(document.location.hash == '#schademelden') {
		    $(".schademelden").show();
		}
	};


	// modal (currently only on service and contact, berichtenbox, polisdetail -> groene kaart)
	// open
	$(document).on("click", ".btn-modal", function() {
		var id = $(this).data("target");
		$(id).modal({
			show: false
		});
	});
	//close
	$(document).on("click", ".btn-modal-close", function() {
		$('.modal').modal("hide");
	});

	function logOut(){
		$("#logout").on('click', function(event) {
			var target = '/avonline/GetBackofficeLogoutAction.do?submit.gebruiktprodukt.uitloggenklant=true&basecrumblepath=MijnOmgeving';
			$.get( target, function(data) {

			}).always(function() {
    			$("#logout").submit();
  			});
			return false;
		});
	};

	function scrollToSomewhere(){
		$("#vue").on('click', 'button', function(event) {
			var target = $($(this).data('href'));
			if(target.length) {
				event.preventDefault();
				$('html, body').stop().animate({
					scrollTop: target.offset().top - 75
				}), 1000;
			}
		});
	};//scrollToSomewhere used for "mijn verzekeringen", "facturen" (paging) and "berichten" (paging).

	function scrollToContact() {
		$('.btn-super').on('click', function(){
			$('html, body').stop().animate({
				scrollTop: $('#scrolltocontact').offset().top - 100
			}), 1001;
		});
	}; //scrollToContact only used for "Service and contact" for now.

	function scrollToReply() {
		$('.serviceencontact').on('click', '.btn-reply', function(){
			var target = $(this);
			$('html, body').stop().animate({
				scrollTop: target.offset().top - 100
			}), 1001;
		});
	}

	function verzekeringenTonen() {
		var polisComponent = $(".insurance.wide");
		var produktList = $(".insurance-list");
		var newButton = $(".produkt-shower");
		var newButton2 = $("h3 + .produkt-shower");

		if( polisComponent.length > 1) {
			produktList.hide();
			 newButton.on("click", function(){
				produktList.fadeIn('slow');
				location.hash = "#nieuweverzekering";
				newButton2.hide();
			})
		}
		else {
			produktList.show();
			newButton2.hide();
		}
	};


	//fix for a bug in Bootstrap 4 Tabs. DO NOT REMOVE TILL BUG IS FIXED BY BOOTSTRAP
	function activeClass(){
		$('.nav-tabs').on('shown.bs.tab', 'a', function (e) {
		    if (e.relatedTarget) {
		        $(e.relatedTarget).removeClass('active');
		    }
		});
	};
	// END BUGFIX


	// inits
	logOut();
	slideInAlert();
	scrollToSomewhere();
	scrollToContact();
	contactForm();
	verzekeringenTonen();
	autoOpen();
	readMore();
	moreDetails();
	formValidator();
	hideLoader();
	showLoginLoader();
	scrollToReply();
	activeClass(); // BOOTSTRAP BUGFIX


});





// WEBPACK FOOTER //
// ./src/main/frontend/mainscripts.js